import { Component } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/SidebarPopupPlace/SidebarPopupPlace.styl'
import Scrollable from 'components/atoms/Scrollable'
import { SidebarPopupPlace, SidebarPopupPlaceProps } from 'components/features/pfm/SidebarPopupPlace/SidebarPopupPlace'

type SidebarScrollablePopupPlaceProps =
  & SidebarPopupPlaceProps
  & {
    alwaysShowScrollbar: boolean
  }

export class SidebarScrollablePopupPlace extends Component<SidebarScrollablePopupPlaceProps> {
  render () {
    const {
      position, targetRect,
      alwaysShowScrollbar,
      children,
    } = this.props

    const rightCorners = position !== 'fill'

    const popupWrapperClassName = cn(styles.popupWrapper, {
      [styles.rightCorners]: rightCorners,
    })

    return (
      <SidebarPopupPlace
        position={ position }
        targetRect={ targetRect }
      >
        <Scrollable heightRelativeToParent='100%' alwaysShowScrollbar={ alwaysShowScrollbar }>
          <div className={ popupWrapperClassName }>
            { children }
          </div>
        </Scrollable>
      </SidebarPopupPlace>
    )
  }
}
